/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./submit-button.vue?vue&type=template&id=66c5177b&scoped=true&"
import script from "./submit-button.vue?vue&type=script&lang=js&"
export * from "./submit-button.vue?vue&type=script&lang=js&"
import style0 from "./submit-button.vue?vue&type=style&index=0&id=66c5177b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c5177b",
  null
  
)

export default component.exports